import React from "react";
// import "./EngagementProcess.css";

export default function EngagementProcess() {
  const steps = [
    {
      num: "1",
      title: "Discovery call",
      text: "Understand your business, structure, pain points and compliance status.",
    },
    {
      num: "2",
      title: "Scope & proposal",
      text: "Define scope, timelines, responsibilities and a transparent fixed/retainer fee.",
    },
    {
      num: "3",
      title: "Document collection",
      text: "Collect data and documents via secure channels with clear checklists.",
    },
    {
      num: "4",
      title: "Execution & review",
      text: "Prepare workings, filings and reports with internal quality checks.",
    },
    {
      num: "5",
      title: "Filing & support",
      text: "File with authorities, share proofs and support in future queries or notices.",
    },
  ];

  return (
    <section className="engagement-section">
      <div className="container">
        <p className="engagement-tag">ENGAGEMENT PROCESS</p>
        <h2 className="section-title">
          Simple, structured way of working
        </h2>
        <p className="engagement-subtitle">
          Whether you are a startup or an established company, we follow a
          clear step-by-step process for every assignment.
        </p>

        <div className="engagement-box">
          {steps.map((step, index) => (
            <div className="engagement-item" key={index}>
              <div className="step-number">{step.num}</div>
              <h4 className="step-title">{step.title}</h4>
              <p className="step-text">{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
